var _templateObject, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgGear = function SvgGear(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    clipPath: "url(#gear_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.262 7.612a1.72 1.72 0 0 0 .976 2.357l1.16.412a1.719 1.719 0 0 1 0 3.24l-1.16.412a1.72 1.72 0 0 0-.976 2.357l.53 1.11A1.72 1.72 0 0 1 17.5 19.79l-1.112-.527a1.72 1.72 0 0 0-2.357.976l-.412 1.16a1.718 1.718 0 0 1-3.239 0l-.412-1.16a1.72 1.72 0 0 0-2.358-.976l-1.11.527A1.718 1.718 0 0 1 4.208 17.5l.528-1.112a1.72 1.72 0 0 0-.976-2.357L2.6 13.62a1.719 1.719 0 0 1 0-3.24l1.16-.412a1.72 1.72 0 0 0 .976-2.355L4.208 6.5A1.718 1.718 0 0 1 6.5 4.208l1.112.528a1.72 1.72 0 0 0 2.356-.974l.412-1.16a1.72 1.72 0 0 1 3.239 0l.412 1.16a1.72 1.72 0 0 0 2.357.976l1.112-.53A1.719 1.719 0 0 1 19.792 6.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.874 12a4.125 4.125 0 1 0 8.25 0 4.125 4.125 0 0 0-8.25 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "gear_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))))));
};
export default SvgGear;